"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  opacity: .4;\n  pointer-events: none;\n"], ["\n  opacity: .4;\n  pointer-events: none;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  background-color:transparent;\n  border-bottom: 1px solid black;\n  border-radius: 0px;\n"], ["\n  background-color:transparent;\n  border-bottom: 1px solid black;\n  border-radius: 0px;\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, .75);\n"], ["\n  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, .75);\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  box-shadow: 0px 4px 4px -3px rgba(0, 0, 0, .75);\n"], ["\n  box-shadow: 0px 4px 4px -3px rgba(0, 0, 0, .75);\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  border: 1px solid red;\n"], ["\n  border: 1px solid red;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  border-bottom: 1px solid red;\n"], ["\n  border-bottom: 1px solid red;\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  color: ", ";\n  border: none;\n  outline: none;\n  font-size: 16px;\n  padding: 5px;\n  border-radius: 5px;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  color: ", ";\n  border: none;\n  outline: none;\n  font-size: 16px;\n  padding: 5px;\n  border-radius: 5px;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var color = function color(props) {
  return props.color || 'black';
};

var hasDisabledProp = function hasDisabledProp(props) {
  return props.disabled && (0, _styledComponents.css)(_templateObject);
};
var hasUnderlinedProp = function hasUnderlinedProp(props) {
  return props.underlined && (0, _styledComponents.css)(_templateObject2);
};
var hasShadowProp = function hasShadowProp(props) {
  return props.shadow && (0, _styledComponents.css)(_templateObject3);
};
var hasShadowWithUnderlinedProp = function hasShadowWithUnderlinedProp(props) {
  return props.shadow && props.underlined && (0, _styledComponents.css)(_templateObject4);
};
var hasErrorWithoutUnderlinedProp = function hasErrorWithoutUnderlinedProp(props) {
  return props.error && !props.underlined && (0, _styledComponents.css)(_templateObject5);
};
var hasErrorWithUnderlinedProp = function hasErrorWithUnderlinedProp(props) {
  return props.error && props.underlined && (0, _styledComponents.css)(_templateObject6);
};

var Base = _styledComponents2.default.input(_templateObject7, color, hasShadowProp, hasDisabledProp, hasUnderlinedProp, hasShadowWithUnderlinedProp, hasErrorWithoutUnderlinedProp, hasErrorWithUnderlinedProp);

var Input = function Input(_ref) {
  var className = _ref.className,
      style = _ref.style,
      type = _ref.type,
      name = _ref.name,
      min = _ref.min,
      max = _ref.max,
      step = _ref.step,
      onKeyPress = _ref.onKeyPress,
      onKeyDown = _ref.onKeyDown,
      onChange = _ref.onChange,
      checked = _ref.checked,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      ref = _ref.ref,
      placeholder = _ref.placeholder,
      color = _ref.color,
      autoFocus = _ref.autoFocus,
      error = _ref.error,
      shadow = _ref.shadow,
      underlined = _ref.underlined,
      disabled = _ref.disabled;
  return _react2.default.createElement(Base, {
    className: className,
    style: style,
    type: type,
    name: name,
    min: min,
    max: max,
    step: step,
    onKeyPress: onKeyPress,
    onKeyDown: onKeyDown,
    onChange: onChange,
    checked: checked,
    value: value,
    defaultValue: defaultValue,
    ref: ref,
    placeholder: placeholder,
    color: color,
    autoFocus: autoFocus,
    error: error,
    shadow: shadow,
    underlined: underlined,
    disabled: disabled
  });
};

exports.default = Input;